
















import {Component, Vue} from "vue-property-decorator";
import {Container} from "typescript-ioc";
import {DeviceControlTmpl, DeviceServiceControlTmpl} from "@/module/device/DeviceControlTmpl";
import DeviceApi from "@/module/device/DeviceApi";
import deviceModule from "@/store/module/DeviceModule";
import VueJsonPretty from 'vue-json-pretty';
import RefreshButton from "@/component/Button/refresh-button.vue";
import {ResourceType} from "@/model/ThingModel";

@Component({
  components: {
    VueJsonPretty,
    RefreshButton,
  }
})
export default class DeviceControlTmplView extends Vue {

  private deviceApi = Container.get(DeviceApi)

  private controlTmpls: Array<DeviceControlTmpl> = []

  private get scontrolTmpls(): Array<DeviceServiceControlTmpl> {
    return this.controlTmpls.filter((it) => {
      return it.resourceType == ResourceType.SERVICE
    }) as Array<DeviceServiceControlTmpl>
  }

  private activeName = ""

  private get device() {
    return deviceModule.active
  }

  private created() {
    this.getControlTmpls()
  }

  private refresh() {
    this.getControlTmpls()
  }

  private async getControlTmpls() {
    this.controlTmpls = await this.deviceApi.controlTmpls(this.device.id)
  }
}
